import { Injectable } from '@angular/core';
import { ITypedResponse } from '@caslink/common-client';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { DashboardDeviceSummary } from '../models/dashboard-device-summary.interface';

@Injectable({
    providedIn: 'root'
})
export class DashboardViewService {
    public static $name = 'dashboardViewService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public showControlsLink(device: DashboardDeviceSummary): boolean {
        if (!device.hardwareItem.areaId || !device.model || !device.model.subroutes) {
            return false;
        }

        return device.hasControlPermission;
    }

    public getControlsLink(device: DashboardDeviceSummary): string {
        const state = device.model.subroutes.currentInfoState.name;

        return this.getStateLink(device, state);
    }

    public getStateLink(device: DashboardDeviceSummary, state: string): string {
        const params = {
            areaId: device.hardwareItem.areaId,
            hardwareItemId: device.hardwareItem.id,
            locationId: device.locationId,
            modelName: device.hardwareCategory,
        };

        return `${state}(${JSON.stringify(params)})`;
    }

    public getControlSummary(hardwareItemId: number): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getControlSummary',
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<any>();
    }

    public updateControlSummary(data: any, hardwareItemId: number): any {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'updateControlSummary',
            data: data.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<any>();
    }

    public getControlsForDevice(hardwareItemId: number): angular.IPromise<CASLink.Device.Ui.ViewModel.Dashboard.DashboardControlViewWrapper> {
        return this.proxyService.request({
                endPoint: 'dashboard',
                route: 'getControlsForDevice',
                routeParams: {
                    hardwareItemId: hardwareItemId
                }
            }
        ).as<CASLink.Device.Ui.ViewModel.Dashboard.DashboardControlViewWrapper>();
    }

    public saveControlSummaryTemplate(device: any, hardwareItemId: number, template: string, fullsnapshot: boolean): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'saveControlSummaryTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateName: template
            },
            queryParams: {
                fullSnapshot: fullsnapshot
            }
        }).as<any>().then((response: any) => {
            return response;
        });
    }

    public previewControlSummaryTemplate(device: any, hardwareItemId: number, template: string, fullsnapshot: boolean): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'previewControlSummaryTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateName: template
            },
            queryParams: {
                fullSnapshot: fullsnapshot
            }
        }).as<CASLink.Ui.ViewModel.ControlSettingTemplates.ControlSettingTemplatesViewModel>();
    }

    

    public getControlSummaryTemplates(hardwareItemId: number): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'getControlSummaryTemplates',
            routeParams: {
                hardwareItemId: hardwareItemId
            }
        }).as<any>();
    }

    public applyControlSummaryTemplate(device: any, hardwareItemId: number, templateId: string): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'applyControlSummaryTemplate',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                templateId: templateId
            }
        }).as<any>();
    }

    public importCaalToControlSummary(device: any, hardwareItemId: number, documentId: number): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'importCaalToControlSummary',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                documentId: documentId
            }
        }).as<any>();
    }

    public exportControlSummaryToCaal(device: any, hardwareItemId: number, documentId: number): angular.IPromise<any> {
        return this.proxyService.request({
            endPoint: 'hardware',
            route: 'exportControlSummaryToCaal',
            data: device.$deviceHierarchy,
            routeParams: {
                hardwareItemId: hardwareItemId,
                documentId: documentId
            }
        }).as<number>().then((response: number) => {
            return response;
        });
    }

}
